module.exports = __webpack_public_path__ + "img/m-banner-ltwjyxtc-vi-VN.6f8f29c6.jpg";